import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import clsx from 'clsx';
import { fetchAllSubcategories } from '../../store/slices/categoriesSlice'; // ✅ Import API action

const NavMenu = ({ menuWhiteClass, sidebarMenu }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    allSubcategories = [],
    loading,
    error,
  } = useSelector((state) => state.categories);

  useEffect(() => {
    dispatch(fetchAllSubcategories());
  }, [dispatch]);

  return (
    <div
      className={clsx(
        sidebarMenu
          ? 'sidebar-menu'
          : `main-menu ${menuWhiteClass ? menuWhiteClass : ''}`
      )}
      style={{
        margin: '1rem',
      }}
    >
      <nav>
        <ul>
          <li>
            <Link to={process.env.PUBLIC_URL + '/'}>
              {t('home')}
              {sidebarMenu ? (
                <span>
                  <i className='fa fa-angle-right'></i>
                </span>
              ) : null}
            </Link>
          </li>

          {/* ✅ Dynamic Categories Dropdown with Red Dot */}
          <li>
            <Link to='#'>
              {t('Categories')}
              {sidebarMenu ? (
                <span>
                  <i className='fa fa-angle-right'></i>
                </span>
              ) : (
                <i className='fa fa-angle-down' />
              )}
            </Link>

            <ul className='mega-menu'>
              {loading ? (
                <li>
                  <p>Loading categories...</p>
                </li>
              ) : error ? (
                <li>
                  <p>Error fetching categories</p>
                </li>
              ) : Array.isArray(allSubcategories) &&
                allSubcategories.length > 0 ? (
                allSubcategories.map((subcategory) => (
                  <li key={subcategory.id}>
                    <ul>
                      <li className='mega-menu-title'>
                        <Link
                          to={`/shop/category/${subcategory.id}`}
                          className='category-item'
                        >
                          {subcategory.name}
                        </Link>
                      </li>
                    </ul>
                  </li>
                ))
              ) : (
                <li>
                  <p>No categories found</p>
                </li>
              )}
            </ul>
          </li>

          <li>
            <Link to={process.env.PUBLIC_URL + '/shop-grid-standard'}>
              {t('collection')}
            </Link>
          </li>

          <li>
            <Link to='#'>
              Company Info
              {sidebarMenu ? (
                <span>
                  <i className='fa fa-angle-right'></i>
                </span>
              ) : (
                <i className='fa fa-angle-down' />
              )}
            </Link>
            <ul className='submenu'>
              <li>
                <Link to={process.env.PUBLIC_URL + '/about-us'}>About Us</Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + '/privacy-policy'}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + '/refund-policy'}>
                  Refund Policy
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to={process.env.PUBLIC_URL + '/contact'}>
              {t('contact_us')}
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

NavMenu.propTypes = {
  menuWhiteClass: PropTypes.string,
  sidebarMenu: PropTypes.bool,
};

export default NavMenu;
